import { Permission } from "./permission.model";

export class CompanyPermissions {
    constructor(public companyName: string, public roles: string[],  public permissions: Permission[]) {

    }
}